const sponsors = [
  { tier: "Gold Sponsor", name: "Boeing" },
  { tier: "Gold Sponsor", name: "ERNST\nHeating & Cooling" },
  { tier: "Community Partner", name: "Metro East\nLutheran High School" },
];

export default function Sponsors() {
  return (
    <section id="sponsors">
      <div className="section-inner">
        <div className="section-eyebrow">Our Supporters</div>
        <div className="section-title">Sponsors &amp; Partners</div>
        <div className="section-divider"></div>

        <div className="sponsors-grid">
          {sponsors.map((sponsor, i) => (
            <div className="sponsor-card" key={i}>
              <div className="sponsor-tier">{sponsor.tier}</div>
              <div className="sponsor-name" style={{ whiteSpace: "pre-line" }}>
                {sponsor.name}
              </div>
            </div>
          ))}
        </div>

        <div className="sponsor-cta">
          <h3>Become a Sponsor</h3>
          <p>
            Your support helps fund robot parts, registration fees, travel, and
            STEM outreach events. Sponsors receive logo placement on our robot,
            pit display, and team materials.
          </p>
          <a href="#contact" className="btn">
            Partner With Us
          </a>
        </div>
      </div>
    </section>
  );
}
